import React, { useEffect } from 'react'
import { useState } from 'react'
import "../../Verfiy.css"
import homeImage from "./verfiyImage/verification.png"
import loader from "./verfiyImage/khiladi_adda_loader.gif"
import axiosClient from '../../axios';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';

import { ReactComponent as Verified } from "./verfiyImage/verified.svg"
import { ReactComponent as Wrong } from "./verfiyImage/wrong.svg"
import { ReactComponent as Pending } from "./verfiyImage/pending.svg"
import { useLocation, useNavigate } from 'react-router-dom'
import Queries from './Queries';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function AadhaarVerify() {
    const search = useLocation().search;

    const status = new URLSearchParams(search).get("message")
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const jwt = localStorage.getItem("JWT");
    const [userAadhar, setUserAadhar] = useState({})
    const [dialog, setDialog] = useState({
        icon: 0,
        message: "Under Process"
    })
    console.log("userAadhar", userAadhar)
    const navigate = useNavigate();
    const handleDelete = () => {
        setOpen(false)
    }
    console.log("status", status)
    const handleOpen = (i, m) => {
        setOpen(true);
        setDialog({
            icon: i,
            message: m
        })
    }

    const fetchAdharDetail = async () => {
        setLoading(true)
        if (status !== "KYC verification updated successfully. Thank you for using Khiladi Adda.") {
            await new Promise((resolve) => setTimeout(resolve, 1000));
            handleOpen(0, status)
            setLoading(false)
            return
        }
        await axiosClient
            .get(`/profile_info`, {
                headers: {
                    'x-access-token': jwt,
                }
            })
            .then((res) => {
                console.log("res", res.data)
                if (res?.data?.status === true) {
                    let userAadhar = res?.data?.response
                    let adharInfo = {
                        name: userAadhar?.name,
                        dob: userAadhar?.dob,
                        aadhaar_number: userAadhar?.aadhar_info?.number,
                        address: userAadhar?.address,
                        city: userAadhar?.city,
                        state: userAadhar?.state,
                        country: userAadhar?.country,
                        zip_code: userAadhar?.zip_code
                    }
                    localStorage.setItem("AADHAR_OTP_DETAILS", JSON.stringify(adharInfo))
                    setUserAadhar(adharInfo)
                }
            }).catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    useEffect(() => {
        fetchAdharDetail()
    }, [status])

    useEffect(() => {
        const preventPullToRefresh = (event) => {
            if (event.touches.length > 1) return;
            event.preventDefault();
        }
        document.addEventListener('touchmove', preventPullToRefresh, { passive: false });
        return () => {
            document.removeEventListener('touchmove', preventPullToRefresh);
        };
    }, []);
    useEffect(() => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () {
            window.location.hash = "no-back-button";
        }
    }, [])
    return (
        <>
            <div className='verfiyMain'>
                <div className='verfiyTop'>
                    <h1>Complete Your AADHAAR KYC</h1>
                </div>
                {loading ?
                    <div className='loaderKaBox'>
                        <img src={loader} alt='loader' className='loaderKA' />
                    </div>
                    : <>

                        <div className='verifyBody'>
                            <div className='homeUImage'>
                                <img src={homeImage} alt="homeImage" />
                            </div>
                            {
                                userAadhar?.name?.length > 2 &&
                                <>
                                    <div className='aadhaarDetails'>
                                        <h3>Aadhaar Details</h3>
                                        <div className='basicDetail'>
                                            <p><span>Name : </span> {userAadhar?.name}</p>
                                            <p><span>DOB : </span> {userAadhar?.dob}</p>
                                            <p><span>Address : </span> {userAadhar?.address}</p>
                                        </div>
                                        <div className='verfiysubmitCover'>
                                            <p className='verifysubmit' onClick={() => navigate("/pan-verfiy")}>Proceed to PAN verify</p>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        <Queries />
                    </>}
            </div>

            <Dialog
                open={open}
                onClose={() => handleDelete()}
                TransitionComponent={Transition}
                className="dialogs"
            >
                <div className='dialogBox'>
                    <div className='dialogCover'>
                        <div className='iconsImage'>
                            {
                                dialog?.icon === 0 ? <Wrong /> : dialog?.icon === 1 ? <Verified /> : <Pending />
                            }
                        </div>
                        <div className='messageBox'>
                            <p>{dialog?.message}</p>
                        </div>
                        <div className='okay' onClick={() => handleDelete()}>Okay</div>
                    </div>
                </div>
            </Dialog >

        </>
    )
}

export default AadhaarVerify